import React from "react"
import SearchBar from "../legacy_components/SearchBar"
import webify from "../util/webify"

export default class TenantSearch extends React.Component {
  constructor(props) {
    super(props);
    const tenantSearchEl = document.getElementById('tenant-search');
    const urlParams = new URLSearchParams(window.location.search);
    this.state = {
      tenants: JSON.parse(tenantSearchEl.dataset.tenants || '[]'),
      selectedTenantId: urlParams.get('tenant_id'),
      baseUrl: tenantSearchEl.dataset.baseUrl
    };
  }

  getCurrentQueryParams = (excludeParams = []) => {
    const urlParams = new URLSearchParams(window.location.search);
    excludeParams.forEach(param => urlParams.delete(param));
    return urlParams;
  }

  performLookup = (query) => {
    const filteredTenants = this.state.tenants.filter(tenant =>
      tenant.name.toLowerCase().includes(query.toLowerCase())
    )
    return Promise.resolve(filteredTenants)
  }

  renderSearchResultRow = (tenant, _resetSearchState) => {
    const params = this.getCurrentQueryParams(['tenant_id']);
    params.set('tenant_id', tenant.id);
    const queryString = params.toString();
    const url = queryString ? `${this.state.baseUrl}?${queryString}` : this.state.baseUrl;

    return (
      <a
        className="block px-2 py-2 hover:no-underline hover:bg-gray-100"
        href={url}
      >
        <div className="font-bold">{tenant.name}</div>
      </a>
    )
  }

  getSelectedTenant = () => {
    if (!this.state.selectedTenantId) return null;
    return this.state.tenants.find(tenant =>
      tenant.id.toString() === this.state.selectedTenantId
    );
  }

  handleDeselect = () => {
    const params = this.getCurrentQueryParams(['tenant_id']);
    const queryString = params.toString();
    const url = queryString ? `${this.state.baseUrl}?${queryString}` : this.state.baseUrl;
    window.location.href = url;
  }

  render() {
    const selectedTenant = this.getSelectedTenant();
    const showAllUrl = (() => {
      const params = this.getCurrentQueryParams(['tenant_id']);
      const queryString = params.toString();
      return queryString ? `${this.state.baseUrl}?${queryString}` : this.state.baseUrl;
    })();

    return (
      <div className="search-bar">
        {selectedTenant && (
          <div className="mb-2 p-2 bg-gray-100 rounded">
            <span className="text-gray-600">Showing Tenant: </span>
            <span className="font-bold">{selectedTenant.name}</span>
            <a
              href={showAllUrl}
              className="ml-2 text-blue-600 hover:text-blue-800 text-sm underline"
            >
              (Show all)
            </a>
          </div>
        )}
        <SearchBar
          renderSearchResultRow={this.renderSearchResultRow}
          performLookup={this.performLookup}
          placeholder="Search for a tenant..."
        />
      </div>
    )
  }
}

webify("tenant-search", TenantSearch)
